// extracted by mini-css-extract-plugin
export var animation = "Header-module--animation--1dd9b";
export var header = "Header-module--header--aeaf2";